import { Col, Row } from 'antd';
import Icon from '@ant-design/icons';
import RefreshSvg from 'global/Icons/RefreshSvg';
import { ReactNode } from 'react';
import { Text } from '../styled';
import { ErrorIcon, RetryButton } from './styled';

interface ErrorStateProps {
  className?: string;
  description?: string | ReactNode;
  buttonText?: string;
  iconSrc?: string;
  iconWidth?: string;
  iconHeight?: string;
  hideRetry?: boolean;
  loading?: boolean;
  onRetry?(): void;
}

const ErrorState = ({
  className,
  description,
  buttonText = 'Try Again',
  iconSrc,
  iconWidth,
  iconHeight,
  hideRetry = false,
  loading = false,
  onRetry = () => {},
}: ErrorStateProps) => (
  <Row className={className} align="middle" justify="center">
    <Col>
      <Row align="middle" justify="center">
        <Col>
          <ErrorIcon src={iconSrc} width={iconWidth} height={iconHeight} />
        </Col>
        <Col span={24}>
          <Text align="center" color="#858585" marginBottom="12px">
            {description}
          </Text>
        </Col>
      </Row>
      {!hideRetry && (
        <Row align="middle" justify="center">
          <Col>
            <RetryButton
              type="text"
              icon={<Icon component={RefreshSvg} />}
              onClick={onRetry}
              spin={loading}
              disabled={loading}
            >
              {buttonText}
            </RetryButton>
          </Col>
        </Row>
      )}
    </Col>
  </Row>
);

export default ErrorState;
